import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fire_detection_and_alarm_system_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'is_the_fire_detection_and_alarm_system_in_line_w_legal_reqs',
  name: 'Is the fire detection and alarm system in line with legal requirements?',
  description:
    'The purpose of a fire detection and alarm system is for early detection and reporting, so as to reduce the time needed to implement fire-fighting measures and to limit the impact of the fire.\r\r\n\r\r\nThe alarm system in this question refers only to fire alarms. Alarms for other emergencies are covered separately.\r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14600,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
